export default __webpack_public_path__ + "static/media/tickGreen.b3d2131c.svg";